import { ClockIcon } from "@/components/Icons/ClockIcon";
import { Badge } from "@/design-system/Badge";

import { EventSchedule } from "./EventSchedule";

export function DatedAnnouncementBadge({
  startsAt,
  endsAt,
  size = "lg",
}: {
  startsAt: Date | string;
  endsAt?: Date | string;
  size?: "sm" | "lg";
}): React.ReactNode {
  return (
    <Badge variant="info" size={size} icon={<ClockIcon />}>
      <EventSchedule startsAt={startsAt} endsAt={endsAt} includeDate />
    </Badge>
  );
}
